$('.js-add-ticket-additional-payment-to-cart').click(function(){

    let data_to_send = {
        action: 'add_additional_ticket_payment_to_cart',
        ticket_id: $(this).data('ticket-id')
    }

    let pressed_button = $(this);

    jQuery.post(BASE_URL+'/wp-admin/admin-ajax.php', data_to_send, function(response){
        if(response){
            response = JSON.parse( response );

            if(response.success){
                notif('success', response.notif);
                refresh_header(response.header);
                pressed_button.text(pressed_button.data('in-cart-text')).removeClass('btn-primary').addClass('btn-warning');
            }else{
                notif(response.notif_type, response.notif);

                if(response.notif_type === 'warning'){
                    pressed_button.text(pressed_button.data('in-cart-text')).removeClass('btn-primary').addClass('btn-warning');
                }
            }
        }
    })
})

$('.js-add-ticket-interval-payment-to-cart').click(function(){
    let data_to_send = {
        action: 'add_ticket_interval_payment_to_cart',
        ticket_id: $(this).data('ticket-id')
    }

    let pressed_button = $(this);

    jQuery.post(BASE_URL+'/wp-admin/admin-ajax.php', data_to_send, function(response){
        if(response){
            response = JSON.parse( response );

            if(response.success){
                notif('success', response.notif);
                refresh_header(response.header);
                pressed_button.text(pressed_button.data('in-cart-text')).removeClass('btn-primary').addClass('btn-warning');
            }else{
                notif(response.notif_type, response.notif);

                if(response.notif_type === 'warning'){
                    pressed_button.text(pressed_button.data('in-cart-text')).removeClass('btn-primary').addClass('btn-warning');
                }
            }
        }
    })
})

$('.js-add-all-ticket-intervals-payment-to-cart').click(function(){
    let data_to_send = {
        action: 'add_all_ticket_intervals_payment_to_cart',
        ticket_id: $(this).data('ticket-id')
    }

    let pressed_button = $(this);

    jQuery.post(BASE_URL+'/wp-admin/admin-ajax.php', data_to_send, function(response){
        if(response){
            response = JSON.parse( response );

            if(response.success){
                notif('success', response.notif);
                refresh_header(response.header);
                pressed_button.text(pressed_button.data('in-cart-text')).removeClass('btn-primary').addClass('btn-warning');
            }else{
                notif(response.notif_type, response.notif);

                if(response.notif_type === 'warning'){
                    pressed_button.text(pressed_button.data('in-cart-text')).removeClass('btn-primary').addClass('btn-warning');
                }
            }
        }
    })
})

$('.js-open-ticket-submitted-data').click(function(e){

    $(this).text( $(this).first().data('open-text') );
    let ticket_id = $(this).data('ticket-id');

    let ticket_data_wrapper = $('.js-ticket-submitted-data[data-ticket-id="' + ticket_id + '"]');
    ticket_data_wrapper.stop();

    if(ticket_data_wrapper.hasClass('opened-ticket-data')){
        ticket_data_wrapper.slideUp().removeClass('opened-ticket-data');
        $(this).text($(this).data('open-text'));
    }else{
        $('.opened-ticket-data').slideUp().removeClass('opened-ticket-data');
        ticket_data_wrapper.slideToggle().addClass('opened-ticket-data');
        $(this).text($(this).data('close-text'));
    }
})

$('.js-select-ticket-date').change(function(){

    let event_form = $('#event_form');
    let service_id = $(this).val();

    add_get_param_to_url('term', $(this).val());

    if(!event_form.hasClass('is_set')) {
        $.ajax({
            type: 'POST',
            url: BASE_URL + '/wp-admin/admin-ajax.php',
            dataType: 'html',
            data: {
                'action': 'load_event_form',
                'event_id': $('#event_id').val(),
                'service_id' : service_id
            },
            success: function (response) {
                event_form.append(response);
                event_form.addClass('is_set');
                event_form.slideDown();
                restrict_event_form_data(service_id);
                if(event_form.data('scroll')){
                    scrollTo(event_form, false, 200);
                }
            }
        });
    }else{
        $('.js-ticket-form-service-id').val(service_id);
        restrict_event_form_data(service_id);
    }
});

function restrict_event_form_data(service_id){

    let restrict_field = $('#cf-summer-hero-camp-2024-prefered_sport');

    // Define the restrictions based on service_id
    let restrictions = {
        '2002': [2, 4, 5],
        '2004': [2],
        '2005': [2],
    };

    if(restrictions[service_id]){
        let restrict_options = restrictions[service_id];

        restrict_options.forEach(function(optionIndex) {
            let restrict_option = $('option:nth-child(' + optionIndex + ')', restrict_field);

            restrict_option
                .attr('disabled', 'disabled')
                .attr('default_text', restrict_option.text())
                .html(restrict_option.text() + ' (vypredané)' );

            // if selected, select first option
            if (restrict_option.is(':selected')) {
                restrict_field.val($('option:not([disabled])', restrict_field).first().val());
            }
        });

    } else {
        // Re-enable all options
        $('option', restrict_field).each(function(){
            if($(this).attr('default_text')){
                $(this).text($(this).attr('default_text'));
                $(this).removeAttr('default_text');
                $(this).removeAttr('disabled');
            }
        });
    }
}

$('.js-download-confirmation-pdf').click(function(){
    let ticket_id = $(this).data('ticket-id');
    window.open('?action=download_confirmation_pdf&ticket_id=' + ticket_id);
});

function after_cf_submit(form, data){

    if(data.hooks_response){
        let add_to_cart_text = $('#ticket_added_to_cart_text').val();

        if(add_to_cart_text && data.alert_class === 'success'){
            notif('success', add_to_cart_text);
            //refresh_header(response.header);
            update_mini_cart_count();
            update_mini_cart_content(false, false, true);
        }
    }else{
        let add_to_cart_error_text = $('#ticket_added_to_cart_error_text').val();
        notif('danger', add_to_cart_error_text);
    }
}

$(document).on('click', '.js-event-choose-day', function(){
    $('.js-available-terms-wrapper').addClass('loading');
    $('.calendar td.active').removeClass('active');
    $(this).addClass('active');

    let day = $(this).data('day');
    let month = $(this).parents('table').data('month');
    let year = $(this).parents('table').data('year');

    let data_to_send = {
        action: 'get_event_calendar_available_terms',
        event_id: $('#event_id').val(),
        month: month,
        year: year,
        day: day,
    };

    jQuery.post(BASE_URL+'/wp-admin/admin-ajax.php', data_to_send, function(response) {
        if(response){
            $('.js-available-terms-wrapper').html(response).removeClass('loading');
            $('.js-event-repeating-term-services').html('');

            if($('.js-selected-repeating_term_id').val() !== ''){
                $('.js-event-repeating-term[data-term-id="'+$('.js-selected-repeating_term_id').val()+'"]').click();
            }
            //add_get_param_to_url('den', day);
            //add_get_param_to_url('mesiac', month);
            //add_get_param_to_url('rok', year);
        }
    })
});

$(document).on('change', '.js-event-repeating-term', function(){

    $('.js-event-repeating-term-services').addClass('loading');

    let term_id = $(this).data('term-id');

    let data_to_send = {
        action: 'get_event_repeating_term_services',
        event_id: $('#event_id').val(),
        term_id: term_id
    };

    jQuery.post(BASE_URL+'/wp-admin/admin-ajax.php', data_to_send, function(response) {
        if(response){
            $('.js-event-repeating-term-services').html(response).removeClass('loading');
            add_get_param_to_url('term_id', term_id);
        }
    })
});

$(document).on('click', '.js-event-repeating-add-to-cart', function(){

    //let calendar = $('.js-calendar-table');
    // let year = calendar.data('year');
    // let month = calendar.data('month');
    // let day = $('.js-choose-day.active').data('day');

    let event_repeating = $('.js-event-repeating-term:checked');

    let services = [];

    $('.js-event-repeating-service-wrapper').each(function() {

        // Nájdeme input typu number v rámci aktuálneho labelu
        let $input = $(this).find('input[type="number"]');
        let quantity = parseInt($input.val(), 10) || 0;

        // Nájdeme id z data atribútu (ak tam nie je, použijeme vlastný id)
        let id = $(this).data('service-id');

        // Pridáme do poľa, ak je množstvo väčšie, ako 0
        if (quantity > 0) {
            services.push({
                id: id,
                quantity: quantity
            });
        }
    });
    
    if(services.length > 0){

        let term_id = event_repeating.data('term-id');

        jQuery.ajax({
            url: BASE_URL+'/wp-admin/admin-ajax.php',
            type: 'POST',
            data: {
                action: 'event_repeating_add_to_cart',
                event_id: $('#event_id').val(),
                term_id: term_id,
                services: services,
            },
            success: function(response) {
                response = JSON.parse( response );
    
                if(response.success){

                    // refresh available terms and services sections

                    $('.js-selected-repeating_term_id').val(term_id);
                    $('.js-event-choose-day.active').click();

                    notif('success', response.notif);
                    refresh_header(response.header);
    
                    $('.js-event-repeating-service-wrapper').each(function() {
                        $(this).find('input[type="number"]').val(0);
                    });
    
                }else{
                    notif('danger', response.notif);
                }
            }
        });
    }else{

    }
});


$('.js-storno-ticket-combined').click(function(){
    if(confirm('Naozaj chcete stornovať túto vstupenku? Táto akcia je nevratná.')) {
        jQuery.ajax({
            url: BASE_URL+'/wp-admin/admin-ajax.php',
            type: 'POST',
            data: {
                action: 'storno_ticket_combined',
                ticket_id: $(this).data('ticket-combined')
            },
            success: function (response) {
                location.reload();
            }
        });
    }
})
